import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './content/css/index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { history } from './helpers';
import configureStore from './helpers/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { datadogRum } from '@datadog/browser-rum';

// Create browser history to use in the Redux store.
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

datadogRum.init({
    applicationId: 'ff31c5fd-1328-4869-90aa-153a853ddf75',
    clientToken: 'pubcbc6167201ae3908ac92aa5e0aeda928',
    site: 'datadoghq.eu',
    service: 'legly',
    env: process.env.NODE_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    trackInteractions: true
});

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    rootElement);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js